import { render, staticRenderFns } from "./CreateAiMagicData.vue?vue&type=template&id=0a834716&scoped=true"
import script from "./CreateAiMagicData.vue?vue&type=script&lang=js"
export * from "./CreateAiMagicData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a834716",
  null
  
)

export default component.exports